<div
    class="vehicle-detail-container flex flex-column gap-4 justify-content-center align-items-center"
>
    <p-card
        class="w-full"
        [header]="'VEHICLE_DETAILS' | translate"
        *ngIf="vehicle"
    >
        <div class="border-300 border-top-1 pt-4 flex flex-column">
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.registrationNumber
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "REGISTRATION_NUMBER" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900"
                        >{{ vehicle.vehicle.model.make.name }} ({{
                            vehicle.vehicle.model.name
                        }}
                        {{ "MODEL" | translate }})
                    </span>
                    <span class="text-500 text-sm"
                        >{{ "VEHICLE_MAKE" | translate }}/{{
                            "MODEL" | translate
                        }}</span
                    >
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.yearOfManufacture
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "YEAR_OF_MANUFACTURE" | translate
                    }}</span>
                </div>
            </div>
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900"
                        >{{ vehicle.vehicle.carryingCapacity }}
                        {{ "Seater" | translate }}</span
                    >
                    <span class="text-500 text-sm">{{
                        "CARRYING_CAPACITY" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900"
                        >{{
                            vehicle.vehicle.weightCategory.name | translate
                        }}
                        ({{
                            vehicle.vehicle.weightCategory.description
                                | translate
                        }})</span
                    >
                    <span class="text-500 text-sm">{{
                        "WEIGHT_CATEGORY" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.engineCapacity
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "ENGINE_CAPACITY" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.status | translate
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "STATUS" | translate
                    }}</span>
                </div>
            </div>
        </div>
    </p-card>
    <p-card
        class="w-full"
        [header]="'VEHICLE_DOCUMENTS' | translate"
        *ngIf="vehicle"
    >
        <p-progressBar
            *ngIf="loadingDocumentView"
            mode="indeterminate"
            [style]="{ height: '6px' }"
        ></p-progressBar>
        <p-table
            [value]="vehicle.documents"
            [rowsPerPageOptions]="[10, 15, 20]"
            responsiveLayout="scroll"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ "DOCUMENT_NAME" | translate }}</th>
                    <th>{{ "DOCUMENT_NUMBER" | translate }}</th>
                    <th>{{ "DATE_UPLOADED" | translate }}</th>
                    <th>{{ "EXPIRY_DATE" | translate }}</th>
                    <th>{{ "MIME_TYPE" | translate }}</th>
                    <th>{{ "STATUS" | translate }}</th>
                    <th>{{ "ACTIONS" | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
                <tr
                    [ngClass]="
                        document.status === 'VERIFIED' ? 'clearBg' : 'orangeBg'
                    "
                >
                    <td>
                        <span class="p-column-title">Document Name</span>
                        {{ document.documentName | translate }}
                    </td>
                    <td>
                        <span class="p-column-title">Document Number</span>
                        {{
                            document.documentNumber
                                ? document.documentNumber
                                : "---"
                        }}
                    </td>
                    <td>
                        <span class="p-column-title">Date Uploaded</span>
                        {{
                            document.uploadDate
                                ? (document.uploadDate | date : "short")
                                : "---"
                        }}
                    </td>
                    <td>
                        <span class="p-column-title">Expiry Date</span>
                        {{
                            document.expiryDate
                                ? (document.expiryDate | date : "short")
                                : "---"
                        }}
                    </td>
                    <td>
                        <span class="p-column-title">Mime Type</span>
                        {{ document.mimeType ? document.mimeType : "---" }}
                    </td>

                    <td>
                        <span class="p-column-title">Expiry Date</span
                        >{{
                            document.status
                                ? (document.status | translate)
                                : "---"
                        }}
                    </td>
                    <td>
                        <span class="p-column-title">Actions</span>
                        <p-button
                            *ngIf="document.status !== 'VERIFIED'"
                            icon="pi pi-info-circle"
                            severity="success"
                            [pTooltip]="'VERIFY_DOCUMENT' | translate"
                            (click)="getKycDocument(document.id)"
                            [rounded]="true"
                        />
                        <div
                            [pTooltip]="'DOCUMENT_VERIFIED_TOOLTIP' | translate"
                            class="w-3rem"
                        >
                            <p-button
                                
                                *ngIf="document.status === 'VERIFIED'"
                                icon="pi pi-info-circle"
                                (onClick)="openVerifiedDocument(document.id, document.mimeType)"
                                [outlined]="true"
                                severity="success"
                                [rounded]="true"
                            />
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="mt-6">
            <p-button
                (onClick)="goToCustomerDetails()"
                icon="pi pi-arrow-left"
                severity="secondary"
                [label]="'BACK_TO_CUSTOMER' | translate"
            ></p-button>
        </div>
    </p-card>
</div>
